const defaultConfig = {
  titleKey: "stat_counter_title",
  itemsKey: "stat_counter_items",
};

export const statCounterWidget = ({ page, config, ...props }) => {
  config = Object.assign({}, defaultConfig, config);

  if (!page || !(config.itemsKey in page) || page[config.itemsKey].length === 0) {
    return null;
  }

  return {
    component: "StatCounterWidget",
    props: {
      title: page[config.titleKey] ?? null,
      items: page[config.itemsKey].map((i) => ({
        label: i.label ?? null,
        value: i.value ?? null,
        prefix: i.value_prefix ?? null,
        suffix: i.value_suffix ?? null,
      })),
      ...props,
    },
  };
};
